'use client';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import Link from 'next/link';

import i18n from '@/src/i18n';
import { sendAnalyticsData, trackNavigation } from '@/src/utils/analytics';

export const AskQuestion = () => {
  // const askAQuestionImage = [
  //   {
  //     imagePath: '/images/ask-a-question/ask-a-question-2x.png',
  //     imageWidth: 1024,
  //     alt: 'Ask a question',
  //   },
  // ];

  return (
    <div className="mt-10 flex flex-col md:mt-20 md:flex-row md:items-center md:gap-x-5">
      <div className="flex md:w-1/2 md:justify-end">
        {/* <OptimisedImage
          data={askAQuestionImage}
          defaultImagePath="/images/ask-a-question/ask-a-question-1x.png"
        /> */}
        <Image
          src="/images/ask-a-question/ask-a-question-2x.png"
          width={1024}
          height={1024}
          alt="Ask a question"
        />
      </div>
      <div className="mt-8 flex flex-col items-start px-8 md:w-1/2">
        <div className="justify-end text-[28px] font-medium text-[#3D3E40] md:text-4xl">
          {i18n.t('Can’t find an answer to your question')}?
        </div>
        <div className="mt-2 text-[17px] font-normal text-[#3D3E40] md:text-2xl">
          {i18n.t('Ask us anything, we are here to help you with your queries')}
          .
        </div>
        <div className="mt-10 rounded-md bg-[#318AE5] px-6 py-4 text-[16px] font-medium text-white hover:bg-[#2B81D9]">
          <Link
            href="/contact-us"
            onClick={() => {
              sendAnalyticsData('ASK_A_QUESTION_BUTTON_CLICKED');
              trackNavigation('contact-us', 'Ask a question');
            }}
          >
            <button>{i18n.t('Ask a question')}</button>
          </Link>
          <ChevronRightIcon className="inline h-5 w-5" />
        </div>
      </div>
    </div>
  );
};

export default AskQuestion;
